import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './UnsavedChangesPopup.module.scss';

interface UnsavedChangesPopupProps {
  onStay: () => void;
  onLeave: () => void;
  title?: string;
  description?: string;
  stayLabel?: string;
  leaveLabel?: string;
}

const UnsavedChangesPopup: React.FC<UnsavedChangesPopupProps> = ({
  onStay,
  onLeave,
  title = 'floorplan.unsavedChanges.title',
  description = 'floorplan.unsavedChanges.description',
  stayLabel = 'floorplan.unsavedChanges.stay',
  leaveLabel = 'floorplan.unsavedChanges.leave'
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2>{t(title)}</h2>
        <p>{t(description)}</p>
        <div className={styles.actions}>
          <Button variant="light" size="sm" onClick={onStay}>{t(stayLabel)}</Button>
          <Button variant="fill" size="sm" onClick={onLeave}>{t(leaveLabel)}</Button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesPopup;
